// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".not-found-warp[data-v-486f7b77]{width:100vw;height:100vh;display:flex;justify-content:center;align-items:center}.not-found-warp img[data-v-486f7b77]{width:70%;height:70%;cursor:pointer}", ""]);
// Exports
module.exports = exports;
